import { ICompetitionApi } from '../types';
import Core from '@mediaplatform/sportal365-football-sdk-v2';

export default (sdk: Core): ICompetitionApi => {
  const getCompetition: ICompetitionApi['getCompetition'] = ({ competitionId, signal }) => {
    if (competitionId) {
      const competition = sdk.competition(competitionId.toString());

      return competition.get({ signal });
    }

    console.warn('No competition is provided');
  };

  return { getCompetition };
};
